
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("cCfRD", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $2Nwuj = parcelRequire("2Nwuj");


var $6f0Oj = parcelRequire("6f0Oj");

var $1GzhS = parcelRequire("1GzhS");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $6r7Ix = parcelRequire("6r7Ix");

var $hjUk0 = parcelRequire("hjUk0");

var $6UUyu = parcelRequire("6UUyu");

var $4cOi8 = parcelRequire("4cOi8");

var $1m9A2 = parcelRequire("1m9A2");

var $3VS69 = parcelRequire("3VS69");

var $cNwLI = parcelRequire("cNwLI");

var $fOKpq = parcelRequire("fOKpq");


var $hECbK = parcelRequire("hECbK");


var $iC0lV = parcelRequire("iC0lV");





var $7CLBv = parcelRequire("7CLBv");


var $abN8T = parcelRequire("abN8T");


var $7q60U = parcelRequire("7q60U");

const $c6068ce67a3314db$var$fetchLocalIdMacroParameters = (editorActions, localId)=>editorActions?.getNodeByLocalId?.(localId)?.toJSON()?.attrs?.parameters ?? null;
const $c6068ce67a3314db$export$b1b4e692d3acce68 = ({ localId: localId, editorActions: editorActions })=>{
    const [spotlightParameters, setSpotlightParameters] = (0, $42omo.useState)(()=>$c6068ce67a3314db$var$fetchLocalIdMacroParameters(editorActions, localId));
    (0, $42omo.useEffect)(()=>{
        setSpotlightParameters($c6068ce67a3314db$var$fetchLocalIdMacroParameters(editorActions, localId));
    }, [
        editorActions,
        localId
    ]);
    const updateParameter = (0, $42omo.useCallback)((updates)=>{
        setSpotlightParameters((prevParams)=>{
            if (!prevParams) return null;
            const updatedSpotlightParams = (0, (/*@__PURE__*/$parcel$interopDefault($7CLBv)))(prevParams);
            updates.forEach(({ path: path, value: value })=>(0, (/*@__PURE__*/$parcel$interopDefault($abN8T)))(updatedSpotlightParams, path, value));
            (0, $7q60U.updateNodeParameters)(editorActions, updatedSpotlightParams);
            return updatedSpotlightParams;
        });
    }, [
        editorActions
    ]);
    const createUpdater = (path)=>(value)=>updateParameter([
                {
                    path: path,
                    value: value
                }
            ]);
    const spotlightActions = {
        updateHeight: createUpdater('height'),
        updateBackgroundColor: createUpdater('backgroundColor'),
        updateCornerStyle: createUpdater('cornerStyle'),
        updateLayout: createUpdater('layout'),
        updateContentTextTitle: createUpdater('content.text.title'),
        updateContentTextDescription: createUpdater('content.text.description'),
        updateContentTextColor: createUpdater('content.text.textColor'),
        updateContentIsButtonShown: createUpdater('content.button.isButtonShown'),
        updateContentButtonText: createUpdater('content.button.text'),
        updateContentButtonLink: createUpdater('content.button.link'),
        updateContentButtonStyle: createUpdater('content.button.style'),
        updateContentImage: (imageSrc, altText)=>{
            updateParameter([
                {
                    path: 'content.image.imageSrc',
                    value: imageSrc
                },
                {
                    path: 'content.image.altText',
                    value: altText
                }
            ]);
        }
    };
    return {
        spotlightParameters: spotlightParameters,
        spotlightActions: spotlightActions
    };
};



var $27Ekc = parcelRequire("27Ekc");




const $60af8bbda9d0ceed$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    title: {
        id: "company-hub.spotlight-extension.config-panel.title",
        defaultMessage: "Spotlight"
    },
    preamble: {
        id: "company-hub.spotlight-extension.config-panel.preamble",
        defaultMessage: "Highlight important messages with a visual spotlight. {supportLink}"
    },
    preambleWithoutSupportLink: {
        id: "company-hub.spotlight-extension.config-panel.preamble-without-support-link",
        defaultMessage: "Highlight important messages with a visual spotlight."
    },
    preambleSupportLinkLabel: {
        id: "company-hub.spotlight-extension.config-panel.preamble-link.label",
        defaultMessage: "Learn more about spotlights"
    },
    stylesTabLabel: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.styles-tab.label",
        defaultMessage: "Styles"
    },
    contentTabLabel: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.content-tab.label",
        defaultMessage: "Content"
    },
    generalTitle: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.general-title",
        defaultMessage: "General"
    },
    layoutsTitle: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.layouts-title",
        defaultMessage: "Layouts"
    }
});


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");





var $1Whri = parcelRequire("1Whri");


var $1s5hv = parcelRequire("1s5hv");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $5n7dr = parcelRequire("5n7dr");

var $fQWPs = parcelRequire("fQWPs");

var $7Ux0V = parcelRequire("7Ux0V");

var $1u5CA = parcelRequire("1u5CA");







var $aPCur = parcelRequire("aPCur");




const $51362cfafe2dd3c9$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    backgroundColor: {
        id: "company-hub.spotlight-extension.spotlight.background.color",
        defaultMessage: "Background color"
    },
    textColor: {
        id: "company-hub.spotlight-extension.spotlight.text.color",
        defaultMessage: "Text color"
    },
    colorValidationSuccessMessage: {
        id: "company-hub.spotlight-extension.spotlight.color-contrast.success",
        defaultMessage: "Your text and background colors work well for readability."
    },
    colorValidationFailMessage: {
        id: "company-hub.spotlight-extension.spotlight.color-contrast.fail",
        defaultMessage: "Your text and background colors don\u2019t work well for readability."
    }
});


const $389f589b0955072f$var$styles = {
    generalOptionStyles: "_1bsb1osq"
};
const $389f589b0955072f$export$2910923bcc04bf2a = ({ parameters: parameters, actions: actions })=>{
    const { isSSRProductInDarkMode: isSSRProductInDarkMode, isCompanyHub: isCompanyHub, branding: branding } = (0, $fOKpq.useProductDependencies)();
    const { hideDefaultColorPalette: hideDefaultColorPalette, brandBackgroundColorMap: brandBackgroundColorMap } = branding ?? {};
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { backgroundColor: backgroundColor, content: content, cornerStyle: cornerStyle } = parameters ?? {};
    const { updateContentTextColor: updateContentTextColor, updateBackgroundColor: updateBackgroundColor, updateCornerStyle: updateCornerStyle } = actions;
    const { backgroundColorMap: backgroundColorMap, emptyColorMap: emptyColorMap, textColorMap: textColorMap } = (0, $1u5CA.useBuiltInColorMap)(isSSRProductInDarkMode);
    const textColor = content?.text?.textColor;
    const isReadableBackgroundColor = (color)=>(0, $fQWPs.isReadable)(color, textColor);
    const isReadableTextColor = (color)=>(0, $fQWPs.isReadable)(color, backgroundColor);
    (0, $7Ux0V.useAutoTransitioningColors)(backgroundColor, isReadableTextColor, textColor, updateContentTextColor, branding?.defaultParameters);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
        testId: "general-options",
        direction: "column",
        xcss: (0, $1Whri.cx)($389f589b0955072f$var$styles.generalOptionStyles),
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
            space: "space.200",
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    alignBlock: "center",
                    spread: "space-between",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            color: "color.text",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                ...(0, $51362cfafe2dd3c9$export$a7357cdd1f0b0168).backgroundColor
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $5n7dr.ColorPicker), {
                            builtInColorMap: hideDefaultColorPalette && brandBackgroundColorMap ? brandBackgroundColorMap : backgroundColorMap,
                            isReadableColor: isReadableBackgroundColor,
                            onChange: updateBackgroundColor,
                            value: backgroundColor,
                            pickerTitle: (0, $51362cfafe2dd3c9$export$a7357cdd1f0b0168).backgroundColor,
                            validationSuccessMessage: formatMessage((0, $51362cfafe2dd3c9$export$a7357cdd1f0b0168).colorValidationSuccessMessage),
                            validationFailMessage: formatMessage((0, $51362cfafe2dd3c9$export$a7357cdd1f0b0168).colorValidationFailMessage),
                            showCustomPalette: isCompanyHub,
                            analyticsSource: "spotlightExtensionConfigBackgroundColor"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    alignBlock: "center",
                    spread: "space-between",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            color: "color.text",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                ...(0, $51362cfafe2dd3c9$export$a7357cdd1f0b0168).textColor
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $5n7dr.ColorPicker), {
                            builtInColorMap: hideDefaultColorPalette ? emptyColorMap : textColorMap,
                            isReadableColor: isReadableTextColor,
                            onChange: updateContentTextColor,
                            value: textColor,
                            pickerTitle: (0, $51362cfafe2dd3c9$export$a7357cdd1f0b0168).textColor,
                            validationSuccessMessage: formatMessage((0, $51362cfafe2dd3c9$export$a7357cdd1f0b0168).colorValidationSuccessMessage),
                            validationFailMessage: formatMessage((0, $51362cfafe2dd3c9$export$a7357cdd1f0b0168).colorValidationFailMessage),
                            showCustomPalette: isCompanyHub,
                            analyticsSource: "spotlightExtensionConfigTextColor",
                            showTextIcon: true
                        })
                    ]
                }),
                isCompanyHub && /*#__PURE__*/ (0, $l998X.jsx)((0, $aPCur.CornerStyleConfig), {
                    cornerStyleValue: cornerStyle,
                    updateCornerStyle: updateCornerStyle,
                    roundCornerValue: (0, $4cOi8.CornerStyle).ROUNDED,
                    squareCornerValue: (0, $4cOi8.CornerStyle).SQUARED
                })
            ]
        })
    });
};












var $inPa6 = parcelRequire("inPa6");


var $dpPtd = parcelRequire("dpPtd");


var $a3fRD = parcelRequire("a3fRD");


var $dcJ7R = parcelRequire("dcJ7R");








var $9EtP6 = parcelRequire("9EtP6");


var $4noo5 = parcelRequire("4noo5");


var $1oCLl = parcelRequire("1oCLl");


var $e1Ppq = parcelRequire("e1Ppq");


var $jQ0mm = parcelRequire("jQ0mm");






var $lEBwV = parcelRequire("lEBwV");




const $4d3865ef7b33e888$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    titleLabel: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.text-title-label",
        defaultMessage: "Title"
    },
    descriptionLabel: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.text-description-label",
        defaultMessage: "Description"
    },
    imageLabel: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.text-image-label",
        defaultMessage: "Image"
    },
    titlePlaceholder: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.text-title-placeholder",
        defaultMessage: "Give your spotlight a title"
    },
    descriptionPlaceholder: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.text-description-placeholder",
        defaultMessage: "Spotlights highlight important messages for your team. Design your spotlight with an image, your custom colors, a short description, and a link."
    },
    aiGenerationErrorFlagTitle: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.ai-generation.error.flag.title",
        defaultMessage: "We couldn't generate your image"
    },
    aiGenerationErrorFlagDescription: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.ai-generation.error.flag.description",
        defaultMessage: "Try again or choose a different image."
    },
    aiGenerationErrorFlagDescriptionWithReason: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.ai-generation.error.flag.description-with-reason",
        defaultMessage: "{errorReason}. Try again or choose a different image."
    }
});


const $bb5db8d720aef330$var$CC_PAGE_EXPERIENCES_PREMIUM_MACROS_IMG_GENERATION = 'cc_page_experiences_premium_macros_img_generation';
const $bb5db8d720aef330$var$wrapperStyles = (0, $ecnYn.xcss)({
    paddingBlock: 'space.100'
});
const $bb5db8d720aef330$export$cc923a32c7b3f62a = ({ parameters: parameters, actions: actions, contentId: contentId })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { cloudId: cloudId, enableLinkInputInMediaPicker: enableLinkInputInMediaPicker } = (0, $fOKpq.useProductDependencies)();
    const isAiImgGenEnabled = (0, $1oCLl.expValEquals)($bb5db8d720aef330$var$CC_PAGE_EXPERIENCES_PREMIUM_MACROS_IMG_GENERATION, 'isEnabled', true);
    const { generateImage: generateImage, aiHeaderImageFileId: aiHeaderImageFileId, aiHeaderImageStatus: aiHeaderImageStatus, error: aiHeaderImageError } = (0, $e1Ppq.useAIGeneratedCoverImage)({
        contentId: contentId
    });
    const { showFlag: showFlag } = (0, $dpPtd.useFlags)();
    const { formatMessage: formatMessage } = intl;
    // Surface a flag to the user when AI image generation fails. We only fire
    // when the status transitions INTO `ERROR` (mirroring the Confluence header
    // image behaviour in EditorPageCoverPicture) so re-renders while already in
    // the error state don't produce duplicate flags.
    //
    // Each fire uses a unique flag `id` so that consecutive failures STACK in
    // the flag tray (matching the Confluence header image behaviour) rather
    // than replacing the previous flag — ADS `useFlags` dedupes by `id`.
    const prevAIHeaderImageStatusRef = (0, $42omo.useRef)(null);
    const aiGenerationErrorFlagCounterRef = (0, $42omo.useRef)(0);
    (0, $42omo.useEffect)(()=>{
        if (!isAiImgGenEnabled) {
            prevAIHeaderImageStatusRef.current = aiHeaderImageStatus;
            return;
        }
        const prevStatus = prevAIHeaderImageStatusRef.current;
        const isTransitioningToError = prevStatus !== 'ERROR' && aiHeaderImageStatus === 'ERROR';
        prevAIHeaderImageStatusRef.current = aiHeaderImageStatus;
        if (!isTransitioningToError) return;
        const description = aiHeaderImageError ? formatMessage((0, $4d3865ef7b33e888$export$a7357cdd1f0b0168).aiGenerationErrorFlagDescriptionWithReason, {
            errorReason: aiHeaderImageError
        }) : formatMessage((0, $4d3865ef7b33e888$export$a7357cdd1f0b0168).aiGenerationErrorFlagDescription);
        aiGenerationErrorFlagCounterRef.current += 1;
        showFlag({
            id: `spotlight-extension-ai-generation-error-flag-${aiGenerationErrorFlagCounterRef.current}`,
            title: formatMessage((0, $4d3865ef7b33e888$export$a7357cdd1f0b0168).aiGenerationErrorFlagTitle),
            description: description,
            icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                label: "",
                size: "medium",
                color: "var(--ds-icon-danger, #C9372C)"
            })
        });
    }, [
        aiHeaderImageStatus,
        aiHeaderImageError,
        isAiImgGenEnabled,
        showFlag,
        formatMessage
    ]);
    const { content: { text: { title: title, description: description }, image: image, button: { text: buttonText, link: buttonLink, style: buttonStyle } }, layout: layout } = parameters;
    const { updateContentTextTitle: updateContentTextTitle, updateContentTextDescription: updateContentTextDescription, updateContentImage: updateContentImage, updateContentButtonText: updateContentButtonText, updateContentButtonLink: updateContentButtonLink, updateContentIsButtonShown: updateContentIsButtonShown, updateContentButtonStyle: updateContentButtonStyle } = actions;
    const isAiHeaderImageLoading = (aiHeaderImageStatus === 'LOADING' || aiHeaderImageStatus === 'LOADING_WITH_ACCEPTANCE_FLOW') && !aiHeaderImageFileId;
    const generateImageRef = (0, $42omo.useRef)(generateImage);
    generateImageRef.current = generateImage;
    const generateAndApplyImage = (0, $42omo.useCallback)(async (props)=>{
        const mediaFileId = await generateImageRef.current(props);
        if (mediaFileId) updateContentImage(mediaFileId, '');
        return mediaFileId;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        updateContentImage
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleFieldAnalytics = (0, $42omo.useCallback)((fieldType, label)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'focused',
                actionSubject: fieldType,
                actionSubjectId: `configPanel${label}TextField`,
                source: 'spotlightExtensionConfig'
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const handleChangeTitle = (0, $42omo.useCallback)((event)=>{
        updateContentTextTitle(event.currentTarget.value);
    }, [
        updateContentTextTitle
    ]);
    const handleChangeDescription = (0, $42omo.useCallback)((event)=>{
        updateContentTextDescription(event.currentTarget.value);
    }, [
        updateContentTextDescription
    ]);
    const handleChangeImage = (0, $42omo.useCallback)((props)=>{
        const imageSrc = 'fullSizeImageUrl' in props ? props.fullSizeImageUrl : props.uploadedImageId;
        const altText = props.altDescription;
        updateContentImage(imageSrc, altText);
    }, [
        updateContentImage
    ]);
    const handleChangeLink = (0, $42omo.useCallback)((linkPayload)=>{
        if (!buttonLink) updateContentIsButtonShown(true);
        updateContentButtonLink(linkPayload.url);
    }, [
        updateContentButtonLink,
        updateContentIsButtonShown,
        buttonLink
    ]);
    const handleClearLink = (0, $42omo.useCallback)(()=>{
        updateContentButtonLink('');
        updateContentIsButtonShown(false);
    }, [
        updateContentButtonLink,
        updateContentIsButtonShown
    ]);
    const handleRemoveButton = (0, $42omo.useCallback)(()=>{
        updateContentButtonLink('');
        updateContentButtonStyle((0, $4cOi8.ButtonStyle).DEFAULT);
        updateContentButtonText('');
        updateContentIsButtonShown(false);
    }, [
        updateContentButtonLink,
        updateContentIsButtonShown,
        updateContentButtonText,
        updateContentButtonStyle
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
        space: "space.200",
        xcss: $bb5db8d720aef330$var$wrapperStyles,
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
                space: "space.050",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                            ...(0, $4d3865ef7b33e888$export$a7357cdd1f0b0168).titleLabel
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $4noo5.default), {
                        maxLength: 100,
                        value: title,
                        onChange: handleChangeTitle,
                        onFocus: ()=>handleFieldAnalytics('textField', 'Title'),
                        placeholder: intl.formatMessage((0, $4d3865ef7b33e888$export$a7357cdd1f0b0168).titlePlaceholder)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
                space: "space.050",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                            ...(0, $4d3865ef7b33e888$export$a7357cdd1f0b0168).descriptionLabel
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $9EtP6.default), {
                        minimumRows: 5,
                        maxLength: 180,
                        value: description,
                        onChange: handleChangeDescription,
                        onFocus: ()=>handleFieldAnalytics('textArea', 'Description'),
                        placeholder: intl.formatMessage((0, $4d3865ef7b33e888$export$a7357cdd1f0b0168).descriptionPlaceholder)
                    })
                ]
            }),
            layout !== (0, $4cOi8.CommonLayout).NO_IMAGE_BACKGROUND && /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                spread: "space-between",
                alignBlock: "center",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                            ...(0, $4d3865ef7b33e888$export$a7357cdd1f0b0168).imageLabel
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $lEBwV.MediaPickerSection), {
                        shouldAllowLinkFromUrl: enableLinkInputInMediaPicker,
                        contentId: contentId,
                        image: image,
                        onChangeImage: handleChangeImage,
                        analyticsSource: "spotlightExtension",
                        generateAIHeaderImage: isAiImgGenEnabled ? generateAndApplyImage : undefined,
                        isAiHeaderImageLoading: isAiImgGenEnabled ? isAiHeaderImageLoading : false
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $jQ0mm.ButtonConfig), {
                cloudId: cloudId,
                link: buttonLink,
                text: buttonText,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-1876
                style: buttonStyle,
                updateButtonText: updateContentButtonText,
                updateButtonStyle: updateContentButtonStyle,
                handleClearButton: handleRemoveButton,
                handleClearLink: handleClearLink,
                handleSelectLink: handleChangeLink,
                source: "spotlightExtension"
            })
        ]
    });
};


const $7d5234fcf3afbf96$var$SOURCE = 'spotlightExtensionConfig';
const $7d5234fcf3afbf96$var$SUPPORT_LINK = 'https://support.atlassian.com/confluence-cloud/docs/highlight-important-messages-with-a-visual-spotlight/';
const $7d5234fcf3afbf96$var$stickyFooterStyles = (0, $ecnYn.xcss)({
    paddingInline: 'space.050',
    paddingBlock: 'space.200',
    display: 'flex',
    flexDirection: 'column',
    position: 'sticky',
    bottom: 'space.0',
    backgroundColor: 'elevation.surface'
});
const $7d5234fcf3afbf96$var$SpotlightFooter = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $7d5234fcf3afbf96$var$stickyFooterStyles,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6r7Ix.ConfigPanelFeedbackCollector), {
            source: "spotlightExtension",
            type: (0, $4cOi8.FeedbackType).SPOTLIGHT
        })
    });
const $7d5234fcf3afbf96$export$9bb8febcc3103da7 = ({ closeConfigPanel: closeConfigPanel, localId: localId, editorActions: editorActions, extensionKey: extensionKey, contentId: contentId })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { spotlightParameters: spotlightParameters, spotlightActions: spotlightActions } = (0, $c6068ce67a3314db$export$b1b4e692d3acce68)({
        localId: localId,
        editorActions: editorActions
    });
    const { showConfigPreambleSupportLink: showConfigPreambleSupportLink } = (0, $fOKpq.useProductDependencies)();
    const PreviewContentComponent = (0, $42omo.useCallback)(({ height: height, layout: layout })=>{
        const extensionNode = {
            extensionKey: (0, $iC0lV.SPOTLIGHT_EXTENSION_KEY),
            extensionType: (0, $cNwLI.SPOTLIGHT_EXTENSION_TYPE),
            // Casting here to satisfy TypeScript and prevent the linter from thinking
            // useCallback is called conditionally.
            parameters: {
                ...spotlightParameters,
                height: height,
                layout: layout
            }
        };
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $27Ekc.Spotlight), {
            isPreviewSize: true,
            extensionNode: extensionNode
        });
    }, [
        spotlightParameters
    ]);
    if (!spotlightParameters) return /*#__PURE__*/ (0, $l998X.jsx)((0, $1m9A2.NoExtensionData), {
        source: extensionKey,
        isConfigPanel: true
    });
    const tabSections = [
        {
            label: intl.formatMessage((0, $60af8bbda9d0ceed$export$a7357cdd1f0b0168).stylesTabLabel),
            value: 'styles',
            tabContent: [
                {
                    title: intl.formatMessage((0, $60af8bbda9d0ceed$export$a7357cdd1f0b0168).generalTitle),
                    sectionId: 'general',
                    defaultIsExpanded: true,
                    component: /*#__PURE__*/ (0, $l998X.jsx)((0, $389f589b0955072f$export$2910923bcc04bf2a), {
                        parameters: spotlightParameters,
                        actions: spotlightActions
                    })
                },
                {
                    title: intl.formatMessage((0, $60af8bbda9d0ceed$export$a7357cdd1f0b0168).layoutsTitle),
                    sectionId: 'layouts',
                    defaultIsExpanded: false,
                    component: /*#__PURE__*/ (0, $l998X.jsx)((0, $hECbK.LayoutOptions), {
                        updateLayout: spotlightActions.updateLayout,
                        source: $7d5234fcf3afbf96$var$SOURCE,
                        layoutOptions: (0, $iC0lV.layoutOptions),
                        PreviewComponent: PreviewContentComponent,
                        currentLayoutSelection: spotlightParameters.layout
                    })
                }
            ]
        },
        {
            label: intl.formatMessage((0, $60af8bbda9d0ceed$export$a7357cdd1f0b0168).contentTabLabel),
            value: 'content',
            tabContent: [
                {
                    sectionId: 'main',
                    component: /*#__PURE__*/ (0, $l998X.jsx)((0, $1GzhS.default), {
                        grow: "fill",
                        space: "space.200",
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $bb5db8d720aef330$export$cc923a32c7b3f62a), {
                            parameters: spotlightParameters,
                            actions: spotlightActions,
                            contentId: contentId
                        })
                    })
                }
            ]
        }
    ];
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6UUyu.ExtensionsConfigWrapper), {
        closeConfigPanel: closeConfigPanel,
        title: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
            ...(0, $60af8bbda9d0ceed$export$a7357cdd1f0b0168).title
        }),
        footerComponent: $7d5234fcf3afbf96$var$SpotlightFooter,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                    ...showConfigPreambleSupportLink ? (0, $60af8bbda9d0ceed$export$a7357cdd1f0b0168).preamble : (0, $60af8bbda9d0ceed$export$a7357cdd1f0b0168).preambleWithoutSupportLink,
                    values: {
                        supportLink: /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                            target: "_blank",
                            href: $7d5234fcf3afbf96$var$SUPPORT_LINK,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                ...(0, $60af8bbda9d0ceed$export$a7357cdd1f0b0168).preambleSupportLinkLabel
                            })
                        })
                    }
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $3VS69.PremiumGateForExtensionConfigPanel), {
                feature: "premiumSpotlightConfig",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hjUk0.ConfigPanelGrouping), {
                    source: $7d5234fcf3afbf96$var$SOURCE,
                    tabSections: tabSections
                })
            })
        ]
    });
};
module.exports["SpotlightConfigPanelContent"] = $7d5234fcf3afbf96$export$9bb8febcc3103da7;

});


//# sourceMappingURL=spotlight.19419d4c.js.map
